module.exports = __webpack_public_path__ + "01_bob_gray.cfd430ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_bob_gray.png
// module id = pgc5
// module chunks = 0